import { baseThemeValues } from 'constants/common';

const baseProps = {
  borderRadius: '5px',
  borderWidth: '1px',
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 400,
  outlineColor: 'palette.transparent',
  outlineWidth: '0px',
};

const labelBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '12px',
  fontWeight: 500,
};

const placeholderBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 400,
};

export const textAreaTheme = {
  disabled: {
    ...baseProps,
    bg: 'palette.neutral.5',
    borderColor: 'palette.neutral.5',
    label: {
      ...labelBase,
      text: 'palette.neutral.40',
    },
    placeholder: {
      ...placeholderBase,
      text: 'palette.neutral.40',
    },
    text: 'palette.neutral.40',
  },
  error: {
    ...baseProps,
    bg: 'palette.surface.4',
    borderColor: 'palette.error.60',
    helpText: {
      fontFamily: baseThemeValues.inherit,
      fontSize: '12px',
      fontWeight: 400,
      text: 'palette.error.60',
    },
    label: {
      ...labelBase,
      text: 'palette.error.60',
    },
    placeholder: {
      ...placeholderBase,
      text: 'palette.error.60',
    },
    text: 'palette.tertiary.95',
  },
  focus: {
    ...baseProps,
    bg: 'palette.surface.5',
    borderColor: 'palette.tertiary.50',
    borderWidth: '1px',
    label: {
      ...labelBase,
      text: 'palette.tertiary.60',
    },
    outlineColor: 'palette.tertiary.50',
    outlineWidth: '1px',
    placeholder: {
      ...placeholderBase,
      text: 'palette.transparent',
    },
    text: 'palette.tertiary.95',
  },
  hover: {
    ...baseProps,
    bg: 'palette.surface.5',
    borderColor: 'palette.tertiary.50',
    label: {
      ...labelBase,
      text: 'palette.tertiary.60',
    },
    placeholder: {
      ...placeholderBase,
      text: 'palette.tertiary.60',
    },
    text: 'palette.tertiary.95',
  },
  inactive: {
    ...baseProps,
    bg: 'palette.surface.4',
    borderColor: 'palette.tertiary.20',
    label: {
      ...labelBase,
      text: 'palette.tertiary.60',
    },
    placeholder: {
      ...placeholderBase,
      text: 'palette.tertiary.50',
    },
    text: 'palette.tertiary.95',
  },
};
